import React, { useMemo } from 'react';
import { ProjectPhase } from 'api/project';
import { getTooltipContent } from 'components/organisms/projects/project-list/columns/phases';
import { getTransformedPhasesForProjectSummary } from 'components/organisms/projects/project-list/helpers/get-phases-aggregate';

export const ProjectPhases = ({
  data,
  isPrivate,
}: {
  data: ProjectPhase[];
  isPrivate?: boolean;
}) => {
  const projectPhases = useMemo(() => {
    let result = getTransformedPhasesForProjectSummary(data ?? []);

    if (!isPrivate) {
      result = result?.filter((phase) => !phase.private);
    }

    return result;
  }, [data, isPrivate]);

  return <>{getTooltipContent(projectPhases)}</>;
};
